// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1OkTB","rootSmall":"AddTileButton_rootSmall__1SgV8"};